import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultPlaceholder = ({
  multi = false
}) => /*#__PURE__*/_jsx(FormattedMessage, {
  message: multi ? 'campaignSelect.multiPlaceholder' : 'campaignSelect.placeholder'
});
export const loadingPlaceholder = /*#__PURE__*/_jsx(LoadingSpinner, {
  grow: true,
  size: "extra-small"
});
export const DropdownFooter = ({
  onClickCreate,
  setShowCreatePanel
}) => {
  const onClick = useCallback(() => onClickCreate ? onClickCreate() : setShowCreatePanel(true), [onClickCreate, setShowCreatePanel]);
  return /*#__PURE__*/_jsx(Link, {
    "data-test-id": "create-campaign-button",
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaignSelect.createCampaign"
    })
  });
};